<template>
<div class="relative">
	<v-form v-model="valid" ref="form">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
		<v-row class="ma-0" style="width: 100%;" align="center" justify="start">
			<v-col cols="12" sm="6" xs="6" md="6" lg="3" class="d-flex justify-start">
				<slot name="breadcrumbs"></slot>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="12" sm="6" xs="6" md="6" lg="2" class="d-flex justify-end">
				<bee-btn context="custom_statement" :action-name="actions.CREATE" :disabled="file_is_locked" color="addingColor" :content="$t('CustomStatementsPage.create-custom-statement')" @click="addDialog = true"></bee-btn>
			</v-col>
			<v-dialog persistent v-model="addDialog" max-width="400px" transition="dialog-top-transition">
			<v-card>
				<v-card-title>
					{{ formTitle }}
				</v-card-title>

				<v-card-text class="pb-0">
					<v-row justify="center">
						<v-col cols="12" class="mx-5">
							<bee-text-field
							    context="custom_statement"
							    :action-name="actions.CREATE"
							    v-model="row.name"
							    :label="$t('CustomStatementsPage.custom-statement-name')"
							    :rules="[rules.required]"
							></bee-text-field>
						</v-col>
						<v-col cols="12" class="mx-5" v-if="row.id">
							<bee-multi-select
								:label="$t('CustomStatementsPage.accounts')"
								:items="configs.accounts.filter(c=>c.type == 2)"
								:item-text="item => item.accounting_no + '-' + item.name"
								item-value="id"
								v-model="row.account_ids"
								context="custom_statement" :action-name="actions.CREATE"
							></bee-multi-select>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions class="px-5">
					<v-btn color="greenDarken1" text @click="save()" :disabled="!valid">
						{{$t('CustomStatementsPage.save')}}
					</v-btn>
					<v-btn color="redDarken1" text @click="reset()">
						{{$t('CustomStatementsPage.cancel')}}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
			</v-dialog>
		</v-row>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
		<v-card flat>
			<v-card-text class="px-3 pt-0">
					<bee-simple-table empty-state="dashes"
						:fixed-header="true"
						context="custom_statement" 
						:action-name="actions.GET"
						@delete="selectedIndex = $event.id; deleteDialog = true" 
						@edit=" row ={...$event}; addDialog=true"
						@statement="statement($event.id)"
						:configs="configs" 
						:with-color="true" :zebra="false"  
						:hide-footer="true" :headers="file_is_locked ? headers_when_file_is_locked : headers" :items="custom_statements">
					</bee-simple-table>
				</v-card-text>
			</v-card>
		<bee-dialog
		    :persistent="true"
		    @handler="confirmDelete()"
		    @close="reset()"
		    v-model="deleteDialog"
		    :title="$t('CustomStatementsPage.delete-the-custom-statement')"
		    :message="$t('CustomStatementsPage.are-you-sure-you-want-to-delete-the-custom-statement')"
		></bee-dialog>
		</div>
	</v-form>
</div>
</template>
<script>
import rules from "../../../validation";
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import actions from "../../../permissions/actions-names.js"
export default {
data: () => ({
	actions,
	selectedIndex: null,
	deleteDialog: false,
	addDialog: false,
	valid: false,
	...rules,
	row: {id: null, name: null, account_ids: null},
}),
methods:{
	reset(){
		Object.keys(this.row).forEach(key => this.row[key] = null)
		this.addDialog = false
		this.deleteDialog = false
		this.$refs.form.resetValidation()
	},
	save(){
		if(!this.row.id)
			this.$store.dispatch("customStatements/create",{ name: this.row.name}).finally(() =>  this.reset())
		else
			this.$store.dispatch("customStatements/update",{ custom_statement: this.row}).finally(() =>  this.reset())
	},
	confirmDelete(){
		this.$store.dispatch("customStatements/delete",{ id: this.selectedIndex }).then(()=>{ store.dispatch("customStatements/fetchAll") }).finally(() =>  this.reset())
	},
	statement(id){
		this.$router.push({ name: "custom-statement", params: { id } });
	}
},
mounted(){
	window.observer.observe(document.querySelector("#tool-bar"))
},
computed: {
	...mapState("customStatements" , ["custom_statements"]),
	...mapState("configs" , ["configs"]),
	formTitle() {
		return !this.row.id
		? this.$t('CustomStatementsPage.create-custom-statement')
		: this.$t('CustomStatementsPage.edit-custom-statement')
	},
	file_is_locked(){
		return this.configs?.financial_file?.is_locked
	},
		
	headers() {
		return [
			{
				text: this.$t('CustomStatementsPage.headers.custom-statement-name'),
				value: 'name',
				type: 'string',
				width: '15%',
				editable: true
			},
			{
				text: this.$t('CustomStatementsPage.headers.used-accounts'),
				value: 'account_ids',
				type: 'multi-select',
				width: '65%',
				editable: true, settings: { itemText: 'name' }
			},
			{
				text: this.$t('CustomStatementsPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%', actions: [
					{ name: 'edit', action_name: actions.EDIT}, 
					{ name: 'delete', action_name: actions.DELETE},  
					{ name: 'statement', action_name: actions.GET},  
				]
			}
		]
	},
	headers_when_file_is_locked(){
		return [
			{
				text: this.$t('CustomStatementsPage.headers.custom-statement-name'),
				value: 'name',
				type: 'string',
				width: '15%',
				editable: true
			},
			{
				text: this.$t('CustomStatementsPage.headers.used-accounts'),
				value: 'account_ids',
				type: 'multi-select',
				width: '65%',
				editable: true,
				settings: { itemText: 'name' }
			},
			{
				text: this.$t('CustomStatementsPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%',
				actions: [{ name: 'statement', action_name: actions.GET}]
			}
		]
	},
},
async beforeRouteEnter(to, from, next) {
	let promises = []

	let custom_statements = JSON.parse(JSON.stringify(store.state.customStatements.custom_statements))
	if(Object.keys(custom_statements).length == 0)
		promises.push(store.dispatch("customStatements/fetchAll"))

	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	if(promises.length)
		await Promise.all(promises)
	next();
}
};
</script>
<style scoped>
.my-border {
  border:1px solid !important;
}
</style>